import { AppFeatureEnabledState } from 'src/generated-types/app-feature'

const emptyState = (): AppFeatureEnabledState => ({ features: {}, integrations: {} })

function isAppFeatureEnabledState(data: unknown): data is AppFeatureEnabledState {
  return (
    typeof data === 'object' &&
    data != null &&
    'features' in data &&
    'integrations' in data
  )
}

/** Normalizes API payload (new shape or legacy feature-only map). */
export function normalizeAppFeatureState(
  data: AppFeatureEnabledState | Record<string, boolean> | undefined,
): AppFeatureEnabledState {
  if (!data) {
    return emptyState()
  }
  if (isAppFeatureEnabledState(data)) {
    return {
      features: data.features ?? {},
      integrations: data.integrations ?? {},
    }
  }
  return { features: data as Record<string, boolean>, integrations: {} }
}
